<gp-modal #reassignRequestPopup
          [closable]="true"
          (closed)="reset()"
          class="reassign-modal">
  <div class="gp-modal-title">
    {{ 'WORKFLOWS.reassign' | translate }}
  </div>
  <div class="gp-modal-body clearfix">
    <div class="col-md-12 form-group">
      <label for="assignee">{{'WORKFLOWS.assignee' | translate}}
        <span class="required">*</span>
      </label>
    </div>
    <div class="col-md-12 form-group">
      <gp-employee-select id="assignee"
                          (selectedChange)="selectUser($event)">
      </gp-employee-select>
    </div>
  </div>
  <div class="gp-modal-footer">
    <div class="btn-bar-wrapper">
      <div class="btn-bar btn-bar-sm btn-bar-align-end">
        <button (click)="reassignRequest(reassignRequestPopup)"
                [disabled]="selectedUser === null"
                class="btn btn-dark p-x-md"
                type="button">
          <i *ngIf="reassigning" class="fa fa-light fa-spinner fa-spin" aria-hidden="true"></i>
          {{ 'FORMS.submit' | translate }}
        </button>
        <button (click)="reassignRequestPopup.close()"
                class="btn btn-secondary p-x-md"
                type="button">
          {{ 'FORMS.cancel' | translate }}
        </button>
      </div>
    </div>
  </div>
</gp-modal>
